import { httpClient } from '@/services/http/httpClient'
import type { FileType } from '@/types/fileType'
import type { IdeaStatus } from '../types'

type CreateIdeaParams = {
  status: IdeaStatus
  title: string
  challengeId: string
  description?: string
  participants?: string[]
  links?: string[]
  fileType?: FileType
  ideaFields?: {
    id: string
    values: string[]
  }[]
  ownerId?: string
  customOwner?: boolean
}

export async function createIdea({
  title,
  description,
  status,
  challengeId,
  participants,
  links,
  fileType,
  ideaFields,
  ownerId,
  customOwner,
}: CreateIdeaParams) {
  const payload = new FormData()

  payload.append('title', title)

  if (description) {
    payload.append('description', description)
  }

  payload.append('status', status)
  payload.append('campaignId', challengeId)

  if (participants?.length) {
    payload.append('ideaUsers', JSON.stringify(participants))
  }
  if (links?.length) {
    const mappedLinks = links.map((link, index) => ({
      id: String(index + 1),
      name: `Link ${index + 1}`,
      url: link,
    }))

    payload.append('externalLinks', JSON.stringify(mappedLinks))
  }

  if (fileType?.file) {
    payload.append('files', fileType.file)
  }

  if (ideaFields?.length) {
    const mappedIdeaFields = ideaFields.map((ideaField) => ({
      id: ideaField.id,
      ideaFieldValues: ideaField.values.map((value) => ({
        value,
      })),
    }))

    payload.append('ideaFields', JSON.stringify(mappedIdeaFields))
  }

  if (ownerId) {
    payload.append('ownerId', ownerId)
    payload.append('customOwner', String(customOwner))
  }

  await httpClient.post('/ideas/ideas', payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
